import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/information-open.png'
import _imports_1 from '@/assets/image/information-close.png'


const _withScopeId = n => (_pushScopeId("data-v-7a4c67ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information" }
const _hoisted_2 = { class: "info-head flex-bwn-ter" }
const _hoisted_3 = { class: "flex-col" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "info-content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "list-title flex-bwn" }
const _hoisted_8 = {
  class: "title line--only",
  style: {"width":"calc(100% - 100px)"}
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "list-footer flex-bwn-ter" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { style: {"font-size":"14px"} }

import { t } from '@/plugins/i18n'
import { ref, reactive, computed, onMounted, nextTick, toRaw } from 'vue'
import { useStore } from 'vuex'
import SPagination from '@/components/common/pagination/index.vue'
import { getInformation, readAll, readRow } from '@/apis/usercenter'
import { getJapanTime } from '@/util/common'
import { useRouter } from 'vue-router'
import { useRtfix, isD2C } from '@/store'
import { ElMessageBox } from 'element-plus'
import { post } from '@/plugins/axios'
import { pageDeliveryAbnormalOrder } from '@/apis/order'
import { getProcessByOrderPage, getProcessBySkuPage } from '@/apis/inShipping'
import { tr } from 'element-plus/lib/locale'
import { getLiveDetailPageHref } from '@/components/LiveCardBox/LiveCard/utils'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const isSub = store.getters.isSub // 是否主账号
const main = () => {
  for (const item of list.value) {
    const box: any = document.querySelector('.information' + item.notifyTemplatePrivateId)
    if (box.offsetHeight > 40) item.closeContent = box.offsetHeight > 40
    if (item.content.indexOf('\n') !== -1) {
      item.content = item.content.split('\n')
    } else {
      item.content = item.content.replace(/(.*)([!！.。;；，,@#$%^&*])(.*)$/, '$1\n$3')
      item.content = item.content.split('\n')
    }
  }
}
const messageNum = computed(() => {
  return store.getters['message/getMessageNum']
})
const setContent = (row: any, type: any) => { row.closeContent = type }

const toRead = (row: any) => {
  if (row.targetMainReadStatus) return
  readRow({
    notifyTemplatePrivateId: row.notifyTemplatePrivateId,
    operateType: row.operateType
  }).then((res: any) => {
    if (res.success) {
      hasReadAll.value = true
      store.dispatch('message/getMessageNum')
      row.targetMainReadStatus = 1
      if (row.closeContent) {
        setContent(row, false)
      }
    }
  })
}

const toReadAll = () => {
  readAll().then((res: any) => {
    if (res.success) {
      store.dispatch('message/getMessageNum')
      for (const v of list.value) {
        if (!v.targetMainReadStatus) {
          v.targetMainReadStatus = 1
          setContent(v, false)
        }
      }
    }
  })
}

const customerShopId = store.getters.curShop

const pageData = reactive({
  pageNum: 1,
  pageSize: 20
})
onMounted(() => {
  getInformationList()
})

const currentPage = computed({
  get () {
    return {
      page: pageData.pageNum,
      limit: pageData.pageSize
    }
  },
  set (v: any) {
    const { page, limit } = v
    pageData.pageNum = page
    pageData.pageSize = limit
    getInformationList()
  }
})

const list: any = ref([])
const total = ref()
const loading = ref(false)
const hasReadAll = ref(true)
const getInformationList = () => {
  loading.value = true
  getInformation({
    targetCustomerShopId: customerShopId,
    pageNum: pageData.pageNum,
    pageSize: pageData.pageSize
  }).then((res: any) => {
    list.value = res.data.records.map((item: any) => {
      // console.log('000', JSON.parse(item.extraContent))
      return {
        ...item,
        targetMainReadStatus: !isSub ? item.targetMainReadStatus : item.targetSubReadStatus,
        extraContentArr: JSON.parse(item.extraContent)
      }
    })
    total.value = res.data.total
    hasReadAll.value = !list.value.some((e: any) => !e.targetMainReadStatus)
    nextTick(() => {
      main()
    })
  }).finally(() => { loading.value = false })
}
/**
 * 跳转到直播页面
 */
const jumpToLivePage = (hyperlink: string, activityId: string): boolean => {
  if (hyperlink === '/live' && activityId) {
    window.location.href = getLiveDetailPageHref(activityId)
    return true
  }
  return false
}
const jumpUrl = async (row: any, type: any) => {
  const objParams = JSON.parse(row.hyperlinkParams)
  if (row.hyperlink) {
    if (row.hyperlink === 'brandManage') {
      router.push(useRtfix('BrandManage'))
      return
    }
    if (row.hyperlink === 'toPayOrder') {
      router.push({ ...useRtfix('OrderList'), query: { platformOrderStatus: 2, platformOrderNo: objParams.params0 } })
      return
    }
    if (jumpToLivePage(row.hyperlink, objParams.params0)) return
    console.log(store.getters.curShop, row.targetCustomerShopId)
    if ((store.getters.curShop !== row.targetCustomerShopId) && row.targetCustomerShopId && (row.targetCustomerId !== row.targetMainCustomerId)) {
      store.dispatch('route/changeShop', row.targetCustomerShopId)
    }
    if (type && row.content[row.content.length - 2].indexOf('へ') > -1) {
      // 设置次品交换还是退款
      router.push({ ...useRtfix('setupShop') })
      return
    }
    if (row.hyperlink.indexOf('/smc') > -1) {
      if (row.hyperlink.indexOf('RewardDetails') > -1) {
        // 跳转奖励明细带参数
        location.href = location.origin + row.hyperlink + '?settleNo=' + (objParams.params0 || '')
        return
      }
      location.href = location.origin + row.hyperlink
      return
    }
    if (row.sourceBizType === '80001') {
      const _content = toRaw(row).content
      let deliveryTaskCode = ''
      _content.forEach((item: any) => {
        if (item.includes(t('$国际运单号$'))) {
          deliveryTaskCode = item?.split(t('$国际运单号$') + ':')?.[1]?.trim()
        }
      })
      let url = ''
      // toc跳转异常订单-待确认运输
      // tob跳转国际发货单管理-待确认运输
      if (isD2C()) {
        const res = await pageDeliveryAbnormalOrder({ platformOrderNo: deliveryTaskCode, deliveryProcessType: 0, pageNum: 1, pageSize: 10 })
        if (res?.data?.records.length > 0) {
          // deliveryProcessType为0代表order整单，1代表sku
          url = `/d2c/order/AbnormalOrder?abnormal=ConfirmType&platformOrderNo=${deliveryTaskCode}&deliveryProcessType=0`
        } else {
          url = `/d2c/order/AbnormalOrder?abnormal=ConfirmType&platformOrderNo=${deliveryTaskCode}&deliveryProcessType=1`
        }
      } else {
        const res = await getProcessByOrderPage({ pageNum: 1, pageSize: 30, deliveryTaskCodeList: [deliveryTaskCode] })
        // console.log(7777, res?.data?.records.length)
        // console.log(6666, res?.data?.records)
        if (res?.data?.records.length > 0) {
          url = `/b2b/inshipping/ShippingList?deliveryStatus=ConfirmType&deliveryTaskCode=${deliveryTaskCode}&confirmTypeValue=ORDER`
        } else {
          url = `/b2b/inshipping/ShippingList?deliveryStatus=ConfirmType&deliveryTaskCode=${deliveryTaskCode}&confirmTypeValue=SKU`
        }
      }
      // console.log(6666, url)

      router.push(url)
      return
    }
    if (row.hyperlink.indexOf('/') > -1) {
      let url: any = (isD2C() ? '/d2c' : '/b2b') + row.hyperlink
      switch (row.sourceBizType) {
        case '60004':
          // 关联商品库-关联异常
          url += ('&thirdItemName=' + objParams.params0)
          break
        case '40003':
          // 异常订单-售后
          url += ('&platformOrderNo3=' + objParams.params0)
          break
        case '40002':
          // 异常订单-申请取消
          url += '&platformOrderNo2=' + objParams.params0 + '&productSku=' + objParams.params1 + '&processManner=1'
          break
        case '40012':
          // 订单列表
          url += ('?platformOrderNo=' + objParams.params0)
          break
        case '40013':
          // 国际物流列表
          // url += ('?deliveryTaskCode=' + objParams.params0)
          break
      }
      console.log(url)
      router.push(url)
    } else {
      let params: any = {}

      switch (row.sourceBizType) {
        case '40004':
          // fba补货计划
          params = { deliveryTaskCode: objParams.params0 }
          break
        case '40006':
          // 国际发货售后
          params = { deliveryTaskCode: objParams.params0 }
          break
        case '20001':
          // oem寻源单列表
          params = { searchSourceOrderNo: objParams.params0 }
          window.location.href = '../../oem/order/oemSourceList?searchSourceOrderNo=' + objParams.params0
          // router.push({ ...useRtfix(row.hyperlink), query: params })
          break
        case '40001':
          // 异常订单问题处理
          params = { platformOrderNo: objParams.params0 }
          break
        case '40003':
          // 国际发货售后 hyperlink: "AfterSale"deliveryTaskCode
          params = { deliveryTaskCode: objParams.params0 }
          break
        case '70002':
          // 账单 hyperlink: "BillList"
          params = { id: objParams.params0, billPayStatus: objParams.params1, type: row.targetCustomerId === row.targetMainCustomerId ? 1 : 2 }
          break
        case '90001':
          // 次转正 hyperlink: "SubstandardList"
          params = { shopProductSku: objParams.params0 }
          break
      }
      console.log('url', { ...useRtfix('SourcingOEM'), query: params })
      // router.push({ ...useRtfix(row.hyperlink), query: params })
      router.push({ ...useRtfix(row.hyperlink), query: params })
    }
  }
}

const checkConfirm = (item: any, record: any) => {
  ElMessageBox.confirm(item.type === 1 ? t('确定后将按照新的货代进行发货') : t('确定后将取消您的国际发货单，您需重新创建'), '', {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消'),
    type: 'warning',
    dangerouslyUseHTMLString: true
  }).then(() => {
    post(item.url, JSON.parse(item.parames)).then(() => {
      getInformationList()
      readRow({
        notifyTemplatePrivateId: record.notifyTemplatePrivateId,
        operateType: item.type === 1 ? 1 : 2
      })
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('我的消息')), 1)
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: _unref(messageNum) === 0,
        class: "information-btn",
        onClick: toReadAll
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('全部已读')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (v) => {
            return (_openBlock(), _createElementBlock("div", {
              key: v.notifyTemplatePrivateId,
              class: _normalizeClass(["list-item rel", [{ unRead: !v.targetMainReadStatus }, { hasRead: v.targetMainReadStatus }]]),
              onClick: ($event: any) => (toRead(v))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(v.title), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["read flex-ter", { unRead: !v.targetMainReadStatus }])
                }, _toDisplayString(v.targetMainReadStatus ? _unref(t)('已读')
              : _unref(t)('未读')), 3)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.content, (i, k) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["list-content", [{ unRead: !v.targetMainReadStatus }, 'information' + v.notifyTemplatePrivateId]]),
                  key: k
                }, [
                  (k === v.content.length - 1 && v.hyperlink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (jumpUrl(v, (k === v.content.length - 1)))
                      }, _toDisplayString(i), 9, _hoisted_9))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(i), 1))
                ], 2))
              }), 128)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  (v.closeContent === true)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        referrerPolicy: "no-referrer",
                        onClick: ($event: any) => (setContent(v, false)),
                        src: _imports_0
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (v.closeContent === false)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        referrerPolicy: "no-referrer",
                        onClick: ($event: any) => (setContent(v, true)),
                        src: _imports_1
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(getJapanTime)(v.createTime)), 1)
              ])
            ], 10, _hoisted_6))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_directive_loading, loading.value]
      ]),
      _createVNode(SPagination, {
        "page-data": _unref(currentPage),
        "onUpdate:page-data": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null)),
        showPagination: true,
        "onUpdate:pageData": getInformationList,
        total: total.value
      }, null, 8, ["page-data", "total"])
    ])
  ]))
}
}

})